import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import styles from "./PrivacyPolicyModal.module.scss";
import Cookies from "js-cookie";
import { WarningAmber } from "@mui/icons-material";

const SaasModal = ({ open, onClose, content, showAcceptButton, userId }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleCheckboxChange = (event) => setIsChecked(event.target.checked);

  const handleAccept = async () => {
    const { data } = await axios.get("/user");
    const userData = data[1].medicube_user_id;

    if (isChecked) {
      setIsSubmitting(true);
      try {
        await axios.post(
          "document_agreement",
          {
            legal_document_id: 2,
            user_type: "system_user",
            user_id: userData,
            patient_id: 0,
            consent_bundle_id: 0,
          },
          {
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        onClose();
      } catch (error) {
        console.error("Failed to send document agreement:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const logOut = () => {
    Cookies.set("token", "");
    axios.defaults.headers.common.Authorization = "";
    window.location.replace("/login");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={showAcceptButton ? null : onClose}
        disableEscapeKeyDown={showAcceptButton}
        className={styles.modal}
      >
        <Box
          className={styles.modalContent}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "80vh", // fixed modal height
          }}
        >
          {/* Scrollable Agreement Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              paddingRight: 2,
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Box>

          {/* Fixed Footer */}
          {showAcceptButton ? (
            <Box
              sx={{
                borderTop: "1px solid #ddd",
                pt: 2,
                mt: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                }
                label="I agree to the Software as a Service Subscription Agreement"
              />

              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                <Button
                  onClick={handleAccept}
                  variant="contained"
                  color="primary"
                  disabled={!isChecked || isSubmitting}
                >
                  Accept
                </Button>

                <Button
                  onClick={handleOpenModal}
                  variant="outlined"
                  color="error"
                >
                  Decline
                </Button>
              </Box>
            </Box>
          ) : (
            <Button onClick={onClose} variant="contained" color="primary">
              Close
            </Button>
          )}
        </Box>
      </Modal>

      {/* Confirmation Modal */}
      <Modal open={showModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <WarningAmber sx={{ fontSize: 40, color: "orange", mb: 2 }} />
          <Typography variant="h6">
            Are you sure you want to decline?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            You will no longer be able to access Medicube services until you
            agree to the updated terms and conditions.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
            <Button onClick={handleCloseModal} variant="contained" color="secondary">
              Go back
            </Button>
            <Button onClick={logOut} variant="contained" color="error">
              Confirm & Exit
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SaasModal;
